/**
 * Review workspace navigation configuration.
 *
 * Consumed by ReviewLayout for desktop sidebar and mobile
 * slide-over panel.
 */

export interface ReviewNavItem {
  label: string;
  path: string;
  description: string;
}

export const REVIEW_NAV_ITEMS: ReviewNavItem[] = [
  { label: 'Overview', path: '/review', description: 'Review workspace summary' },
  { label: 'Review Queue', path: '/review/queue', description: 'Applications awaiting review' },
  { label: 'Application Details', path: '/review/applications', description: 'View individual applications' },
  { label: 'History', path: '/review/history', description: 'Chronological status history' },
  { label: 'Search', path: '/review/search', description: 'Search applications by criteria' },
  { label: 'Settings', path: '/review/settings', description: 'Review preferences' },
];
